"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusIndicator = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var check_circle_1 = __importDefault(require("adp-react-icons/lib/fa/check-circle"));
var info_circle_1 = __importDefault(require("adp-react-icons/lib/fa/info-circle"));
var exclamation_circle_1 = __importDefault(require("adp-react-icons/lib/fa/exclamation-circle"));
var warning_1 = __importDefault(require("adp-react-icons/lib/fa/warning"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var StatusIndicatorIcons = {
  'success': {
    icon: react_1.default.createElement(check_circle_1.default, null)
  },
  'info': {
    icon: react_1.default.createElement(info_circle_1.default, null)
  },
  'error': {
    icon: react_1.default.createElement(exclamation_circle_1.default, null)
  },
  'warning': {
    icon: react_1.default.createElement(warning_1.default, null)
  },
  'pending': {
    icon: react_1.default.createElement(warning_1.default, null)
  }
};
var StatusIndicator = function StatusIndicator(props) {
  var _a;
  var statusIndicatorClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('status-indicator')] = true, _a[vdl_prefix_1.vdlPrefix("status-indicator--" + props.size)] = !!props.size, _a[vdl_prefix_1.vdlPrefix("status-indicator--" + props.type)] = !!props.type, _a['disabled'] = props.disabled, _a);
  return react_1.default.createElement("div", {
    key: "status-indicator",
    className: classnames_1.classNames(props.className, statusIndicatorClasses)
  }, react_1.default.createElement("div", {
    className: vdl_prefix_1.vdlPrefix('status-indicator__container')
  }, react_1.default.createElement("div", {
    className: vdl_prefix_1.vdlPrefix('status-indicator__icon')
  }, StatusIndicatorIcons[props.type] && StatusIndicatorIcons[props.type].icon), props.children && react_1.default.createElement("div", {
    className: vdl_prefix_1.vdlPrefix('status-indicator__content-container')
  }, react_1.default.createElement("div", {
    className: vdl_prefix_1.vdlPrefix('status-indicator__content')
  }, props.children))));
};
exports.StatusIndicator = StatusIndicator;
exports.StatusIndicator.propTypes = {
  className: prop_types_1.default.string,
  children: prop_types_1.default.node,
  disabled: prop_types_1.default.bool,
  size: prop_types_1.default.oneOf(['sm', 'md', 'lg']),
  type: prop_types_1.default.oneOf(['success', 'info', 'error', 'warning', 'pending'])
};
exports.StatusIndicator.defaultProps = {
  disabled: false,
  size: 'sm'
};
exports.StatusIndicator.displayName = 'StatusIndicator';